import { useState } from "react";
import { useRoom } from "../room/useRoom";

export function RoomBar() {
  const { roomId, createRoom, joinRoom, leaveRoom, copyLink } = useRoom();
  const [input, setInput] = useState("");

  if (roomId) {
    return (
      <div className="flex flex-wrap items-center gap-3 border-b border-[var(--border)] px-4 py-3 text-sm">
        <span className="text-[var(--muted)]">Room</span>
        <code className="rounded-md bg-[var(--surface)] px-2 py-1 font-mono">{roomId}</code>
        <button type="button" onClick={copyLink} className="rounded-md border border-[var(--border)] px-3 py-1">Copy link</button>
        <button type="button" onClick={leaveRoom} className="rounded-md border border-[var(--border)] px-3 py-1">Leave</button>
      </div>
    );
  }

  return (
    <div className="flex flex-wrap items-center gap-3 border-b border-[var(--border)] px-4 py-3 text-sm">
      <button
        type="button"
        onClick={createRoom}
        className="rounded-lg bg-[var(--color-accent)] px-4 py-2 font-medium text-white"
      >
        Create room
      </button>
      <form
        onSubmit={(e) => { e.preventDefault(); const id = input.trim(); if (id) joinRoom(id); }}
        className="flex items-center gap-2"
      >
        <input
          value={input}
          onChange={(e) => setInput(e.target.value)}
          maxLength={64}
          autoComplete="off"
          placeholder="Enter room id"
          aria-label="Room id"
          className="rounded-md border border-[var(--border)] bg-[var(--surface)] px-3 py-2"
        />
        <button type="submit" className="rounded-md border border-[var(--border)] px-3 py-2">Join</button>
      </form>
    </div>
  );
}
